<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
    name: "App",
    created() {
        this.ajaxUserInfo();//获取用户信息
    },
    methods: {
        ...mapActions("userInfo", ["ajaxUserInfo"]),//刷新用户数据方法
    }
};
</script>

<style lang="less">
@import "./styles/common.less";
@import "./styles/ucCommon.less";
// 全站公共控件与弹层主题。
@import "./styles/site-theme.less";
@import "../static/iconfont/iconfont.css";
@import "./styles/feedback-states.less";
</style>



// WEBPACK FOOTER //
// src/App.vue